<template>
  <div class="mycontent">
    <ViewUserProfile :user="user" />
  </div>
</template>

<script>
import ViewUserProfile from "../components/components-base/profile/ViewUserProfile.vue";
import { mapActions, mapGetters } from "vuex";
import authService from "../services/planning/AuthService";

export default {
  name: "UserProfile",
  components: { ViewUserProfile },
  data() {
    return {
      editable: false,
      user: null,
    };
  },

  created() {
    this.initialize();
    this.user = authService.getUser();
    // this.user.imagePath = "http://www.dawan.fr/images/institutionnel-logo.png";
  },
  methods: {
    ...mapActions("locationModule", ["loadLocations"]),

    initialize() {
      this.loadLocations();
    },

    onReset(e) {
      let currentAuth = authService.getAuth();
      currentAuth.user = e;
      // authService.logout();
      // authService.setAuth(currentAuth);
      this.editable = !this.editable;
    },
    onSave() {},
  },
};
</script>

<style lang="scss">
.mycontent {
  width: 95%;
  padding: 10px 20px;
  margin: auto;
  justify-content: space-between;
  align-items: flex-start;

  .togel-edit-btn {
    color: rgb(231, 231, 231);
  }
}
</style>
